import type { Asset } from "@forgepoint/shared";
import { FileViewer } from "./FileViewer";

interface AssetViewerProps {
  asset: Asset;
  className?: string;
}

/**
 * Component that normalizes Asset data and delegates rendering to FileViewer.
 * Handles web-optimized views when available, falling back to original asset URLs.
 *
 * @param asset - The Asset object containing file information and URLs
 * @param className - Optional CSS classes to apply to the viewer
 * @returns FileViewer component with normalized asset data
 */
export function AssetViewer({ asset, className }: AssetViewerProps) {
  const viewUrl = asset.webViewExternalUrl || asset.externalUrl;
  const fileType = asset.webViewFileType || asset.fileType || "";
  const fileName = (asset.webViewFileName ?? asset.fileName).toLowerCase();
  const displayName = asset.fileName || "";

  return (
    <FileViewer
      viewUrl={viewUrl}
      fileType={fileType}
      fileName={fileName}
      displayName={displayName}
      className={className}
    />
  );
}
